/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cloud_logic_custom": [
        {
            "name": "shurikonektfeapi",
            "endpoint": "https://p41slyspq5.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:3d0d207d-05e8-411e-abf7-77cb29642f92",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_CO8KRMZid",
    "aws_user_pools_web_client_id": "4ef23i7v2h0ggjgv1pqoemetvu",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "shurikonektfe-20230913211459-hostingbucket-master",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d2nhmi3a09xhv8.cloudfront.net"
};


export default awsmobile;
